<template>
	<span
		v-if="certificationText"
		:class="[
			'cert',
			{
				'cert--is': isCertification,
				'cert--not': !isCertification,
			},
		]"
	>
		{{ certificationText }}
	</span>
</template>
<script>
	import { Right, Left } from 'monet';
	import * as R from 'ramda';

	export default {
		name: 'IsCertification',
		props: {
			isCertification: {
				type: null,
				default: null,
			},
		},
		computed: {
			certificationText() {
				return R.pipe(
					v => (typeof v === 'boolean' ? Right(v) : Left(v)),
					R.map(v => (v ? '인증완료' : '미인증')),
					v => v.toMaybe(),
					v => v.getOrElse('')
				)(this.isCertification);
			},
		},
	};
</script>
<style lang="scss" scoped>
	.cert {
		display: inline-block;
		padding: 0.25em 0.35em;
		border-radius: 4px;
	}

	.cert--is {
		color: $font-blue;
		background: #aecfff;
	}

	.cert--not {
		color: $red;
		background: #fdeced;
	}
</style>
